<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Running Text</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">This is running text menu</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Running Text</h4>

              <!-- Switch -->
              <div class="form-check form-switch">
                <button
                  class="btn btn-success"
                  v-b-modal.modal-1
                  @click="isAdd = true"
                >
                  <i class="fe fe-plus-circle"></i>
                  <span class="ms-2">Create new</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input
                  v-model="searchTerm"
                  class="w-auto"
                  placeholder="Type Here..."
                ></b-form-input>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'range'">
                    {{
                      `Between ${formatDate(
                        props.row.start_date
                      )} and ${formatDate(props.row.expire_date)}`
                    }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-sm btn-warning me-2"
                      @click="updateData(props.row)"
                    >
                      Edit
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      @click.prevent="remove(props.row.id)"
                    >
                      Delete
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="
                          (value) => props.pageChanged({ currentPage: value })
                        "
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-1"
        size="lg"
        hide-footer
        title="Form Notification Running Text"
      >
        <form @submit.prevent="saveAdd()" v-if="isAdd === true">
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col-6">
                <label>Target Type</label>
                <v-select
                  v-model="bodyAdd.target_type"
                  :reduce="(option) => option.id"
                  :options="targetTypeOpt"
                  v-validate="'required'"
                  name="Target Type"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Target Type')"
                  >{{ errors.first("Target Type") }}</span
                >
              </div>
              <div
                v-if="bodyAdd.target_type === 'PERSON'"
                class="form-group col-6"
              >
                <label>Target Value</label>
                <v-select
                  v-model="bodyAdd.target_value"
                  :options="users"
                  label="fullname"
                  :reduce="(e) => e.keycloak_id"
                  name="Target Value"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Target Value')"
                  >{{ errors.first("Target Value") }}</span
                >
              </div>
              <div class="form-group col-6">
                <label>Priority</label>
                <v-select
                  v-model="bodyAdd.priority"
                  :reduce="(option) => option.id"
                  :options="priorityOpt"
                  v-validate="'required'"
                  name="Priority"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Priority')"
                  >{{ errors.first("Priority") }}</span
                >
              </div>
              <div class="form-group col-6">
                <label>Title</label>
                <input
                  type="text"
                  v-model="bodyAdd.title"
                  class="form-control"
                  placeholder="Title"
                  v-validate="'required'"
                  name="Title"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Title')"
                  >{{ errors.first("Title") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Marquee Text</label>
                <input
                  type="text"
                  v-model="bodyAdd.marquee_text"
                  class="form-control"
                  placeholder="Marquee Text"
                  v-validate="'required'"
                  name="Marquee Text"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Marquee Text')"
                  >{{ errors.first("Marquee Text") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Duration (in seconds)</label>
                <input
                  type="number"
                  v-model="bodyAdd.duration"
                  class="form-control"
                  placeholder="Duration"
                  v-validate="'required'"
                  name="Duration"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Duration')"
                  >{{ errors.first("Duration") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Delay (in second)</label>
                <input
                  type="number"
                  v-model="bodyAdd.delay"
                  class="form-control"
                  placeholder="Delay"
                  v-validate="'required'"
                  name="Delay"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Delay')"
                  >{{ errors.first("Delay") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Start Date</label>
                <b-form-input
                  type="date"
                  v-model="bodyAdd.start_date"
                  class="form-control"
                  placeholder="Start Date"
                  v-validate="'required'"
                  name="Start Date"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start Date')"
                  >{{ errors.first("Start Date") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Start Time</label>
                <input
                  type="time"
                  v-model="bodyAdd.start_time"
                  class="form-control"
                  placeholder="Start Time"
                  v-validate="'required'"
                  name="Start Time"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start Time')"
                  >{{ errors.first("Start Time") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Expire Date</label>
                <b-form-input
                  type="date"
                  v-model="bodyAdd.expire_date"
                  class="form-control"
                  placeholder="Expire Date"
                  v-validate="'required'"
                  name="Expire Date"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expire Date')"
                  >{{ errors.first("Expire Date") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Expire Time</label>
                <input
                  type="time"
                  v-model="bodyAdd.expire_time"
                  class="form-control"
                  placeholder="Expire Time"
                  v-validate="'required'"
                  name="Expire Time"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expire Time')"
                  >{{ errors.first("Expire Time") }}</span
                >
              </div>
              <div class="mb-3 form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="exampleCheck1"
                  v-model="bodyAdd.checkNotif"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Push Notification</label
                >
              </div>
              <div v-if="bodyAdd.checkNotif == true" class="form-group col-6">
                <label>Scheduling</label>
                <v-select
                  v-model="bodyAdd.scheduling"
                  :reduce="(option) => option.id"
                  :options="pushNotif"
                  v-validate="'required'"
                  name="Scheduling"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Priority')"
                  >{{ errors.first("Priority") }}</span
                >
              </div>
              <div
                v-if="
                  bodyAdd.scheduling == 'schedule' && bodyAdd.checkNotif == true
                "
                class="form-group col"
              >
                <label>Scheduling Value</label>
                <input
                  type="datetime-local"
                  v-model="bodyAdd.schedulingValue"
                  class="form-control"
                  placeholder="Schedule Value"
                />
              </div>
              <div
                v-if="
                  bodyAdd.scheduling == 'daily' && bodyAdd.checkNotif == true
                "
                class="form-group col-3"
              >
                <label>Scheduling Value</label>
                <input
                  type="time"
                  v-model="bodyAdd.schedulingValue"
                  class="form-control"
                  placeholder="Schedule Value"
                  v-validate="'required'"
                  name="Schedule Value"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Schedule Value')"
                  >{{ errors.first("Schedule Value") }}</span
                >
              </div>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>

        <form @submit.prevent="saveUpdate()" v-else>
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col-6">
                <label>Target Type</label>
                <v-select
                  v-model="bodyUpdate.target_type"
                  :reduce="(option) => option.id"
                  :options="targetTypeOpt"
                  v-validate="'required'"
                  name="Target Type"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Target Type')"
                  >{{ errors.first("Target Type") }}</span
                >
              </div>
              <div
                v-if="bodyUpdate.target_type === 'PERSON'"
                class="form-group col-6"
              >
                <label>Target Value</label>
                <v-select
                  v-model="bodyUpdate.target_value"
                  :options="users"
                  label="fullname"
                  :reduce="(e) => e.keycloak_id"
                  name="Target Value"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Target Value')"
                  >{{ errors.first("Target Value") }}</span
                >
              </div>
              <div class="form-group col-6">
                <label>Priority</label>
                <v-select
                  v-model="bodyUpdate.priority"
                  :reduce="(option) => option.id"
                  :options="priorityOpt"
                  v-validate="'required'"
                  name="Priority"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Priority')"
                  >{{ errors.first("Priority") }}</span
                >
              </div>
              <div class="form-group col-6">
                <label>Title</label>
                <input
                  type="text"
                  v-model="bodyUpdate.title"
                  class="form-control"
                  placeholder="Title"
                  v-validate="'required'"
                  name="Title"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Title')"
                  >{{ errors.first("Title") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Marquee Text</label>
                <input
                  type="text"
                  v-model="bodyUpdate.marquee_text"
                  class="form-control"
                  placeholder="Marquee Text"
                  v-validate="'required'"
                  name="Marquee Text"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Marquee Text')"
                  >{{ errors.first("Marquee Text") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Duration (in seconds)</label>
                <input
                  type="number"
                  v-model="bodyUpdate.duration"
                  class="form-control"
                  placeholder="Duration"
                  v-validate="'required'"
                  name="Duration"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Duration')"
                  >{{ errors.first("Duration") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Delay (in second)</label>
                <input
                  type="number"
                  v-model="bodyUpdate.delay"
                  class="form-control"
                  placeholder="Delay"
                  v-validate="'required'"
                  name="Delay"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Delay')"
                  >{{ errors.first("Delay") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Start Date</label>
                <b-form-input
                  type="date"
                  v-model="bodyUpdate.start_date"
                  class="form-control"
                  placeholder="Start Date"
                  v-validate="'required'"
                  name="Start Date"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start Date')"
                  >{{ errors.first("Start Date") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Start Time</label>
                <input
                  type="time"
                  v-model="bodyUpdate.start_time"
                  class="form-control"
                  placeholder="Start Time"
                  v-validate="'required'"
                  name="Start Time"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start Time')"
                  >{{ errors.first("Start Time") }}</span
                >
              </div>
            </div>
            <div class="row g-3">
              <div class="form-group col">
                <label>Expire Date</label>
                <b-form-input
                  type="date"
                  v-model="bodyUpdate.expire_date"
                  class="form-control"
                  placeholder="Expire Date"
                  v-validate="'required'"
                  name="Expire Date"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expire Date')"
                  >{{ errors.first("Expire Date") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Expire Time</label>
                <input
                  type="time"
                  v-model="bodyUpdate.expire_time"
                  class="form-control"
                  placeholder="Expire Time"
                  v-validate="'required'"
                  name="Expire Time"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expire Time')"
                  >{{ errors.first("Expire Time") }}</span
                >
              </div>
              <div class="mb-3 form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="exampleCheck1"
                  v-model="bodyUpdate.checkNotif"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Push Notification</label
                >
              </div>
              <div
                v-if="bodyUpdate.checkNotif == true"
                class="form-group col-6"
              >
                <label>Scheduling</label>
                <v-select
                  v-model="bodyUpdate.scheduling"
                  :reduce="(option) => option.id"
                  :options="pushNotif"
                  v-validate="'required'"
                  name="Scheduling"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Priority')"
                  >{{ errors.first("Priority") }}</span
                >
              </div>
              <div
                v-if="
                  bodyUpdate.scheduling == 'schedule' &&
                  bodyUpdate.checkNotif == true
                "
                class="form-group col"
              >
                <label>Scheduling Value</label>
                <input
                  type="datetime-local"
                  v-model="bodyUpdate.schedulingValue"
                  class="form-control"
                  placeholder="Schedule Value"
                />
              </div>
              <div
                v-if="
                  bodyUpdate.scheduling == 'daily' &&
                  bodyUpdate.checkNotif == true
                "
                class="form-group col-3"
              >
                <label>Scheduling Value</label>
                <input
                  type="time"
                  v-model="bodyUpdate.schedulingValue"
                  class="form-control"
                  placeholder="Schedule Value"
                  v-validate="'required'"
                  name="Schedule Value"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Schedule Value')"
                  >{{ errors.first("Schedule Value") }}</span
                >
              </div>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>
      </b-modal>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../../assets/js/theme.bundle";
import "../../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "locationComponent",
  computed: {
    columns() {
      return this.$store.getters["running_text/columns"];
    },
    list() {
      return this.$store.getters["running_text/list"];
    },
    users() {
      return this.$store.getters["user/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      isAdd: true,
      isLoading: false,
      bodyAdd: {
        target_type: "",
        target_value: "",
        priority: "",
        title: "",
        marquee_text: "",
        duration: "",
        delay: "",
        start_date: moment().format("YYYY-MM-DDThh:mm:ss"),
        start_time: "",
        expire_date: moment().format("YYYY-MM-DDThh:mm:ss"),
        expire_time: "",
        checkNotif: false,
        scheduling: "",
        schedulingValue: "",
      },
      bodyUpdate: {
        id: "",
        target_type: "",
        target_value: "",
        priority: "",
        title: "",
        marquee_text: "",
        duration: "",
        delay: "",
        start_date: "",
        start_time: "",
        expire_date: "",
        expire_time: "",
        checkNotif: false,
        scheduling: "",
        schedulingValue: "",
      },
      targetTypeOpt: [
        { label: "PERSON", id: "PERSON" },
        { label: "ALL", id: "ALL" },
      ],
      priorityOpt: [
        { label: "Announcement", id: 1 },
        { label: "Warning", id: 2 },
        { label: "Urgent", id: 3 },
      ],
      pushNotif: [
        { label: "Now", id: "now" },
        { label: "Schedule", id: "schedule" },
        { label: "Daily", id: "daily" },
      ],
    };
  },
  mounted() {
    this.getList();
    this.getUser();
  },
  methods: {
    getList() {
      this.$store.dispatch("running_text/GET_LIST");
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    format(value, event) {
      return moment(value).format("YYYY-MM-DDThh:mm:ss");
    },
    updateData(props) {
      this.$bvModal.show("modal-1");
      this.isAdd = false;
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.target_type = props.target_type;
      this.bodyUpdate.target_value = props.target_value;
      this.bodyUpdate.priority = props.priority;
      this.bodyUpdate.title = props.title;
      this.bodyUpdate.marquee_text = props.marquee_text;
      this.bodyUpdate.duration = props.duration / 1000;
      this.bodyUpdate.delay = props.delay / 1000;
      this.bodyUpdate.start_date = moment(props.start_date).format(
        "YYYY-MM-DD"
      );
      this.bodyUpdate.start_time = props.start_time;
      this.bodyUpdate.expire_date = moment(props.expire_date).format(
        "YYYY-MM-DD"
      );
      this.bodyUpdate.expire_time = props.expire_time;
      this.bodyUpdate.checkNotif = props.has_push_notif;
      this.bodyUpdate.scheduling = props.pn_scheduling;
      this.bodyUpdate.schedulingValue = props.pn_scheduling != 'now' ? props.pn_scheduling_value : moment().format("YYYY-MM-DDThh:mm");
      console.log(this.bodyUpdate.checkNotif);
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        const data = {
          target_type: this.bodyAdd.target_type,
          target_value: this.bodyAdd.target_value,
          priority: this.bodyAdd.priority,
          title: this.bodyAdd.title,
          marquee_text: this.bodyAdd.marquee_text,
          duration: this.bodyAdd.duration * 1000,
          delay: this.bodyAdd.delay * 1000,
          start_date: this.bodyAdd.start_date,
          start_time: this.bodyAdd.start_time,
          expire_date: this.bodyAdd.expire_date,
          expire_time: this.bodyAdd.expire_time,
          has_push_notif: this.bodyAdd.checkNotif,
          pn_scheduling: this.bodyAdd.scheduling,
          pn_scheduling_value: this.bodyAdd.scheduling != 'now' ? this.bodyAdd.schedulingValue : moment().format("YYYY-MM-DDThh:mm"),
        };
        // return console.log(data);
        try {
          this.isLoading = true;
          this.$store.dispatch("running_text/CREATE", data).then((resp) => {
            this.$swal({
              title: "Saved",
              text: "Your input has been saved",
              icon: "success",
              confirmButtonText: "OK",
            }).then((resp) => {
              this.isLoading = false;
              this.getList();
              this.$bvModal.hide("modal-1");
            });
          });
        } catch (resp) {
          this.$swal("Error", "Error while add data", "error");
        }
      });
    },
    saveUpdate() {
      const data = {
        id: this.bodyUpdate.id,
        target_type: this.bodyUpdate.target_type,
        target_value: this.bodyUpdate.target_value,
        priority: this.bodyUpdate.priority,
        marquee_text: this.bodyUpdate.marquee_text,
        duration: this.bodyUpdate.duration * 1000,
        delay: this.bodyUpdate.delay * 1000,
        start_date: this.bodyUpdate.start_date,
        start_time: this.bodyUpdate.start_time,
        expire_date: this.bodyUpdate.expire_date,
        expire_time: this.bodyUpdate.expire_time,
        title: this.bodyUpdate.title,
        has_push_notif: this.bodyUpdate.checkNotif,
        pn_scheduling: this.bodyUpdate.scheduling,
        pn_scheduling_value: this.bodyUpdate.schedulingValue,
      };
      // return console.log(data);
      this.isLoading = true;
      this.$store
        .dispatch("running_text/UPDATE", data)
        .then((resp) => {
          this.$swal({
            title: "Saved",
            text: "Your data has been change",
            icon: "success",
            confirmButtonText: "OK",
          }).then((resp) => {
            this.isLoading = false;
            this.getList();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.$swal("Error", "Error while edit data", "error");
        });
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("running_text/DELETE", { id: id }).then(() => {
            this.$swal(
              "Success",
              "Running text is has been deleted",
              "success"
            );
            this.getList();
          });
        }
      });
    },
    async getUser() {
      this.$store.dispatch("user/GET_LIST");
    },
  },
};
</script>
